<template>
    <a-modal title="温馨提示" :width="1000" :open="$store.state.indexPop.visible" @cancel="cancel" @ok="handleModalOk"
        :maskClosable="false">
        <div v-if="$store.state.indexPop.popupData.workOrder_list.length > 0">
            <div class="form-tips-title">未办结的工单</div>
            <a-row v-for="(item, index) in $store.state.indexPop.popupData.workOrder_list">
                <a-col :span="2">{{ index + 1 }}</a-col>
                <a-col :span="22">{{ item.title }}</a-col>
            </a-row>
        </div>
        <div v-if="$store.state.indexPop.popupData.period_list.length > 0">
            <div class="form-tips-title">已通过未付款的单</div>
            <a-row v-for="(item, index) in $store.state.indexPop.popupData.period_list">
                <a-col :span="2">{{ index + 1 }}</a-col>
                <a-col :span="22">{{ item.full_name }}{{ item.remark }}</a-col>
            </a-row>
        </div>
        <div v-if="$store.state.indexPop.popupData.unfinish_list.length > 0">
            <div class="form-tips-title">超过一个月未办结的单</div>
            <a-row v-for="(item, index) in $store.state.indexPop.popupData.unfinish_list">
                <a-col :span="2">{{ index + 1 }}</a-col>
                <a-col :span="22">{{ item.full_name }}{{ item.created_at }}</a-col>
            </a-row>
        </div>

    </a-modal>
</template>
<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
const $store = useStore()

const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
}
const state = reactive<IState>({
    loading: false,
})
onMounted(() => {

})
const cancel = () => {
    $store.dispatch('indexPop/closePopup')
}
const handleModalOk = () => {
    $store.dispatch('indexPop/closePopup')
}
</script>

<style lang="less" scoped></style>
